// AI Generated Component
import { Component, Input } from '@angular/core';
import { PageFixListService } from '@client/app/modules/page-fix/services/list/list.service';

@Component({
    selector: 'page-fix-summary-table',
    standalone: false,
    template: `
        <table-container [collection]="pageFixes" [noResultMessage]="'No corrections added to PageCorrect' | translate">
            <table class="table table-hover table-fixed">
                <thead>
                <tr>
                    <th class="col-22" translate>
                        Issue
                    </th>
                    <th class="col-18" translate>
                        Changed to
                    </th>
                    <th class="col-8 text-right" translate>
                        Updated At
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let autofix of pageFixes; trackBy: trackByFn">
                    <td class="text-ellipsis text-v-middle">
                        <div *ngIf="autofix.fixable_type === 'SpellingError'" class="d-flex text-ellipsis">
                            <icon-circle [icon]="['SIDEMENUES', 'QA', 'MISSPELLINGS'] | monIcons" [color]="'text-link'" aria-hidden="true" class="pl-1 pr-3">
                            </icon-circle>
                            <div>
                                <span translate>Misspelling</span>
                                <div class="mt-2" *ngFor="let error of getErrors(autofix); index as index; trackBy: trackByErrorFn">
                                    <span class="label label-danger">
                                        {{error}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="autofix.fixable_type === 'AccessibilitySourceCode' || autofix.fixable_type === 'AccessibilityCheck'" class="d-flex text-ellipsis">
                            <icon-circle [icon]="['MENUES', 'ACCESSIBILITY'] | monIcons" [color]="'text-link'" aria-hidden="true" class="pl-1 pr-3">
                            </icon-circle>
                            <div>
                                <span translate>Accessibility Snippet</span>
                                <div class="mt-2" *ngFor="let error of getErrors(autofix); index as index; trackBy: trackByErrorFn">
                                    <span class="label label-danger">
                                        {{error}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="autofix.fixable_type === 'Link' && autofix.change.attribute === 'href'"
                             class="d-flex text-ellipsis">
                            <icon-circle [icon]="['SIDEMENUES', 'QA', 'BROKEN_LINKS'] | monIcons" [color]="'text-link'" aria-hidden="true" class="pl-1 pr-3">
                            </icon-circle>
                            <div>
                                <span translate>Broken link</span>
                                <div class="mt-2" *ngFor="let error of getErrors(autofix); index as index; trackBy: trackByErrorFn">
                                    <span class="label label-danger">
                                        {{error}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="autofix.fixable_type === 'Link' && autofix.change.attribute === 'src'"
                             class="d-flex text-ellipsis">
                            <icon-circle [icon]="['SIDEMENUES', 'QA', 'BROKEN_IMAGES'] | monIcons" [color]="'text-link'" aria-hidden="true" class="pl-1 pr-3">
                            </icon-circle>
                            <div>
                                <span translate>Broken Image</span>
                                <div class="mt-2" *ngFor="let error of getErrors(autofix); index as index; trackBy: trackByErrorFn">
                                    <span class="label label-danger">
                                        {{error}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="autofix.fixable_type === 'custom'" class="d-flex text-ellipsis">
                            <icon-circle [icon]="['PAGE_FIX', 'CUSTOM'] | monIcons" [color]="'text-link'" aria-hidden="true" class="pl-1 pr-3">
                            </icon-circle>
                            <div>
                                <span translate>Custom rule</span>
                                <div class="mt-2" *ngFor="let error of getErrors(autofix); index as index; trackBy: trackByErrorFn">
                                    <span class="label label-danger">
                                        {{error}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="text-v-middle text-ellipsis">
                        <page-fix-changeset-spelling *ngIf="autofix.fixable_type === 'SpellingError'" [data]="autofix">
                        </page-fix-changeset-spelling>
                        <page-fix-changeset-accessibility
                                *ngIf="autofix.fixable_type === 'AccessibilitySourceCode' || autofix.fixable_type === 'AccessibilityCheck'" [data]="autofix">
                        </page-fix-changeset-accessibility>
                        <page-fix-changeset-link *ngIf="autofix.fixable_type === 'Link'" [data]="autofix">
                        </page-fix-changeset-link>
                        <page-fix-changeset-custom *ngIf="autofix.fixable_type === 'custom'" [data]="autofix">
                        </page-fix-changeset-custom>
                    </td>
                    <td class="text-right text-v-middle">
                        {{ autofix.updated_at | userDate:'ll' }}
                    </td>
                </tr>
                </tbody>
            </table>
        </table-container>
    `,
})
export class PageFixSummaryTableComponent {
    @Input() pageFixes: any[] = [];

    constructor (private pageFixListService: PageFixListService) {}

    getErrors (pageFix: any): any[] {
        return this.pageFixListService.getError(pageFix);
    }

    trackByFn (index: number, item: any): any {
        return item.id || index;
    }

    trackByErrorFn (index: number, error: any): any {
        return error || index;
    }
}
